const searchParams = new URLSearchParams(window.location.search);

const wcaProdHost =
  searchParams.get('wca_prod_host') || 'www.worldcubeassociation.org';

export const PRODUCTION =
  searchParams.has('wca_prod_host') ||
  (process.env.NODE_ENV === 'production' && !searchParams.has('staging'));

export const WCA_ORIGIN = `https://${wcaProdHost}`;

export const WCA_OAUTH_CLIENT_ID = 'TB4PD7JMip7TPipMh207DFbbYRWpG_81m-UHOTMEcrg';

